import { ReduxState } from "ra-core";
import * as React from "react";
import { useSelector } from "react-redux";
import CustomizedSlider from "./CustomSlider";
export const Loading = props => {
  const loading = useSelector<ReduxState>(state => state.admin.loading > 0);
  return <CustomizedSlider loading={loading} />;
};
export default Loading;
